import { type ReadyStore } from './types';

export const initialState: ReadyStore = {
	schedules: null,
	status: 'idle',
};
